module.exports = __webpack_public_path__ + "img/menuPasteWhite.806bec26.svg";